<template>
  <v-select
    filled
    :hide-details="!isRequired"
    :label="title"
    :items="fields"
    :rules="rules"
    :value="value"
    @input="onInput"
  ></v-select>
</template>

<script>
import ui from "../../../services/ui";

export default {
  name: "ServerDataTypePicker",

  props: ["title", "isRequired", "value"],

  data() {
    return {
      fields: [],
    };
  },

  computed: {
    rules() {
      return this.isRequired
        ? ui.requiredRules(this.$store.getters.required)
        : [];
    },
  },

  mounted() {
    this.$store
      .dispatch("cache/getObject", { apiName: "types/data_type" })
      .then((v) => (this.fields = v));
  },

  methods: {
    onInput(e) {
      this.$emit("input", e);
    },
  },
};
</script>